/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { forwardRef } from 'react';

import { jsx } from '@compiled/react';

import { cssMap, cx } from '@atlaskit/css';

import { TBody as PTBody, type TBodyProps } from '../../ui/primitives/tbody';

const styles = cssMap({
	body: {
		position: 'relative',
		display: 'grid',
		border: 'none',
	},
});

/**
 * __Table body__
 */
export const TBody = forwardRef<HTMLTableSectionElement, TBodyProps>(
	({ children, xcss, ...props }, ref) => {
		return (
			<PTBody xcss={cx(styles.body, xcss)} ref={ref} {...props}>
				{children}
			</PTBody>
		);
	},
);
